module.exports = __webpack_public_path__ + "sunsemweb/img/3.2547779a.png";